import React from 'react'
import { useToggle } from 'react-use'
import { ButtonGroup } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import type { Blog } from '@ztechapps/common.contract'
import { BusyButton } from '@ztechapps/webui.button'
import { BlogContainer } from '../BlogContainer'
import styles from './BlogPreview.module.scss'

export type BlogPreviewProps = {
  blog: Blog
}

export const BlogPreview = ({ blog }: BlogPreviewProps) => {
  const [isFullWidth, setIsFullWidth] = useToggle(false)

  return (
    <div className={isFullWidth ? styles.fullWidth : styles.controlled}>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <meta httpEquiv="Cache-Control" content="no-store" />
      </Helmet>

      <div className="d-flex justify-content-between align-items-center gap-2 px-3 py-2 border-bottom bg-body sticky-top">
        <span className="small text-secondary">Standalone preview · outside admin</span>
        <ButtonGroup>
          <BusyButton
            text="Controlled width"
            variant={!isFullWidth ? 'primary' : 'outline-secondary'}
            active={!isFullWidth}
            onClick={() => setIsFullWidth(false)}
          />
          <BusyButton
            text="Full width"
            variant={isFullWidth ? 'primary' : 'outline-secondary'}
            active={isFullWidth}
            onClick={() => setIsFullWidth(true)}
          />
        </ButtonGroup>
      </div>

      <BlogContainer blog={blog} />
    </div>
  )
}
